import React from 'react';
import logo from '../static/logo.jpg';
import './css/Footer.css';

export default () => (
  <div className="footer">
    <p className="footer_p">
      © Diva Models - Nordlandsvej 86 - 8240 Risskov - Denmark
    </p>
    <img className="footer_img" src={logo} alt="logo" />
  </div>
);
